import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { g } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { CalendarDays, ArrowRight } from "lucide-react";

/** Chi c'è stasera: la riga che si guarda prima di aprire il locale. */
export const ChiCeStasera = () => {
  const [d, setD] = useState(null);

  useEffect(() => {
    g("/shifts/today").then(setD).catch(() => setD(null));
  }, []);

  if (!d?.enabled || !d.rows.length) return null;

  const inTurno = d.rows.filter((r) => !r.off);
  const fuori = d.rows.filter((r) => r.off);

  return (
    <Card className="p-6" data-testid="chi-ce-stasera">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
          <CalendarDays className="h-3.5 w-3.5" /> Chi c'è oggi
        </p>
        <Link to="/turni" className="inline-flex items-center gap-1 text-xs font-semibold text-slate-600 hover:text-slate-900" data-testid="chi-ce-stasera-link">
          Calendario turni <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>

      {inTurno.length === 0 ? (
        <p className="mt-3 text-sm text-slate-500" data-testid="chi-ce-stasera-vuoto">
          Nessuno in turno oggi: se non è giusto, sistema il calendario.
        </p>
      ) : (
        <div className="mt-3 flex flex-wrap gap-2">
          {inTurno.map((r) => (
            <span key={r.name} className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800">
              {r.name} · {r.nota}
            </span>
          ))}
        </div>
      )}

      {fuori.length > 0 && (
        <p className="mt-3 text-xs text-slate-500">
          Non in servizio: {fuori.map((r) => `${r.name} (${r.nota})`).join(" · ")}
        </p>
      )}
    </Card>
  );
};
